// generated from 15 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const lastEnrolledInAnyControlFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("last_enrolled_in_any_control_filter"),
  comparison_key: z.enum([
    "6", // 10 (66.67%)
    "3", // 3 (20.00%)
    "4", // 2 (13.33%)
  ]),
  display_name: z.string(),
  // undefined: 6 (40.00%), defined 9 (60.00%)
  raw_value: z.number().nonnegative().optional(),
  value: z.union([
    // number samples: 12 (80.00%)
    // integer: 11 (91.67%)
    // avg: 9.58, min: 0.9583333333333333, max: 30
    z.number().nonnegative(),
    // string samples: 3 (20.00%)
    common.date,
  ]),
  varies_by_app_group: z.literal(false),
});
